import { render, staticRenderFns } from "./CancellationLayout.vue?vue&type=template&id=997b09ca"
var script = {}
import style0 from "./CancellationLayout.vue?vue&type=style&index=0&id=997b09ca&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports